import { red } from '@mui/material/colors';
import { StyleSheet, Font } from '@react-pdf/renderer';


import NaanumGothicRegular from "common/fonts/Nanum_Gothic/NanumGothic-Regular.ttf";
import NaanumGothicBold from "common/fonts/Nanum_Gothic/NanumGothic-Bold.ttf";
import KaushanScriptRegular from "common/fonts/Kaushan_Script/KaushanScript-Regular.ttf";
import MingzatRegular from "common/fonts/Mingzat/Mingzat-Regular.ttf";
import OleoScriptRegular from "common/fonts/Oleo_Script/OleoScript-Regular.ttf";
import OleoScriptBold from "common/fonts/Oleo_Script/OleoScript-Bold.ttf";
import InconsolataBold from "common/fonts/Inconsolata/static/Inconsolata-Bold.ttf"
import InconsolataLight from "common/fonts/Inconsolata/static/Inconsolata-Light.ttf"
import InconsolataMedium from "common/fonts/Inconsolata/static/Inconsolata-Medium.ttf"
import InconsolataRegular from "common/fonts/Inconsolata/static/Inconsolata-Regular.ttf"
import InconsolataExtraExpandedRegular from "common/fonts/Inconsolata/static/Inconsolata_ExtraExpanded-Regular.ttf"
import InterItalic from "common/fonts/Inter/Inter-Italic-VariableFont_opsz,wght.ttf";
import Inter from "common/fonts/Inter/Inter-VariableFont_opsz,wght.ttf";
import MontserratItalic from "common/fonts/Montserrat/Montserrat-Italic-VariableFont_wght.ttf";
import Montserrat from "common/fonts/Montserrat/Montserrat-VariableFont_wght.ttf";



Font.register({
    family: 'Calibri',
    fonts: [
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf", format: 'truetype' },
        { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf", fontWeight: "bold", format: 'truetype' }
    ]
});
Font.register({ family: 'Mingzat', src: KaushanScriptRegular, fontWeight: 'normal'  });
Font.register({ family: 'KaushanScript', src: KaushanScriptRegular, fontWeight: 'normal'  });
Font.register({ family: 'Montserrat', src:Montserrat });
Font.register({ family: 'MontserratItalic', src:MontserratItalic });
Font.register({ family: 'Inter', src:Inter });
Font.register({ family: 'InterItalic', src:InterItalic });

Font.register({
    family: 'Iconsolata',
    fonts: [
        { src: InconsolataLight, fontWeight: 'light' },
        { src: InconsolataBold, fontWeight: 'bold' },
        { src: InconsolataMedium, fontWeight: 'medium' },
        { src: InconsolataRegular, fontWeight: 'regular' },
        { src: InconsolataExtraExpandedRegular, fontWeight: 'expandedRegular' },
    ]
});
Font.register({
    family: 'NanumGothic',
    fonts: [
        { src: NaanumGothicRegular, fontWeight: 'normal' },
        { src: NaanumGothicBold, fontWeight: 'bold' }
    ]
});

Font.register({
    family: 'OleoScript',
    fonts: [
        { src: OleoScriptRegular, fontWeight: 'normal' },
        { src: OleoScriptBold, fontWeight: 'bold' }
    ]
});

const pageStyle = StyleSheet.create({
    page: {
        display: 'flex',
        flexDirection: 'column',
        padding: 10,
        backgroundColor: "#f5f5f5",  // Light background
    },
    page_border: {
        paddingVertical: 20,
        paddingHorizontal: 30,
        border: "5px solid #4a90e2", // Blue border
        borderRadius: 25,
        backgroundColor: "#fff", // White background inside
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Soft shadow
        height: '100%',
        width: '100%',
        backgroundImage: "linear-gradient(to right, #f6d365, #fda085)", // Gradient background
    },
    header_section: {
        flex: 4,
        borderBottom: "2px solid #ddd",
        paddingBottom: 10,
    },
    certificate_content_section: {
        flex: 15,
        marginTop: 20,
    },
    footer_section: {
        flex: 4,
        marginTop: 10,
        paddingTop: 10,
        borderTop: "1px solid #ddd",
    },
});


const fontStyles = StyleSheet.create({
    textCenterSmallBold: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 10,
        color: '#000',
        // borderWidth: 1,
        // borderColor: "#000",
    },
    textLeftSmall: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 14,
        color: '#000',
    },
    textLeftNormal: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 18,
        color: '#000',
    },
    textCenterNormalInter: {
        fontFamily: 'Inter',
        justifyContent: "center",
        textAlign: "center",
        fontSize: 16,
        color: '#000',
    },
    textCenterBigBold: {
        fontFamily: 'NanumGothic',
        fontWeight: "medium",
        justifyContent: "center",
        textAlign: "center",
        fontSize: 26,
        color: '#000',
    },
    textSchool: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "center",
        fontWeight: "bold",
        fontSize: 36,
        color: '#000',
    },
    fontKaushan: {
        fontFamily: 'KaushanScript',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 14,
        color: '#000',
    },
    fontOleo: {
        fontFamily: 'OleoScript',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 14,
        color: '#000',
    },
    fontOleoBold: {
        fontFamily: 'OleoScript',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "bold",
        fontSize: 14,
        color: '#000',
    },
    fontNaunamGauthic: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 14,
        color: '#000',
    },
    fontNaunamGauthicBold: {
        fontFamily: 'NanumGothic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "bold",
        fontSize: 14,
        color: '#000',
    },
    fontNaunamGauthicMedium: {
        fontFamily: 'NanumGothic',
        fontWeight: "medium",
        justifyContent: "center",
        textAlign: "left",
        fontSize: 14,
        color: '#000',
    },
    fontInconsolataRegular: {
        fontFamily: 'Inconsolata',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "regular",
        fontSize: 14,
        color: '#000',
    },
    fontInconsolataExpandedRegular: {
        fontFamily: 'Inconsolata',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "expandedRegular",
        fontSize: 14,
        color: '#000',
    },
    fontInconsolataLight: {
        fontFamily: 'Inconsolata',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "light",
        fontSize: 14,
        color: '#000',
    },
    fontInconsolataBold: {
        fontFamily: 'Inconsolata',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "bold",
        fontSize: 14,
        color: '#000',
    },
    fontInconsolataMedium: {
        fontFamily: 'Inconsolata',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "medium",
        fontSize: 14,
        color: '#000',
    },
    fontMingzatMedium: {
        fontFamily: 'Mingzat',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "normal",
        fontSize: 14,
        color: '#000',
    },
    fontMontserrat: {
        fontFamily: 'Montserrat',
        justifyContent: "center",
        textAlign: "left",
        // fontWeight: "italic",
        fontSize: 14,
        color: '#000',
    },
    fontMontserratItalic: {
        fontFamily: 'MontserratItalic',
        justifyContent: "center",
        textAlign: "left",
        fontWeight: "bold",
        fontSize: 14,
        color: '#000',
        
    },
    fontInter: {
        fontFamily: 'Inter',
        fontSize: 18,
        justifyContent: "center",
        textAlign: "left",
        color: '#000',
    },
    fontInterItalic: {
        fontFamily: 'InterItalic',
        justifyContent: "center",
        textAlign:"left",
        alignItems:"flex-start",
        alignContent:"flex-start",
        alignSelf:"flex-start",
        fontSize: 16,
        color: '#000',
        lineHeight:1.75,
        
    },
    boldText: {
        fontFamily: 'NanumGothic',
        fontWeight: 'bold',
        fontSize: 16, // You can adjust this as needed
        color: '#000',
        textAlign:"left",
        alignItems:"flex-start",
        alignContent:"flex-start",
        alignSelf:"flex-start",
    },
});

const styleContent = StyleSheet.create({
    content_section: {
        flex: 1,
        flexDirection: "column",
    },
    date: {
        flex: 4,
        // paddingHorizontal:"20%",
        paddingHorizontal: 10,
        marginTop:20,
    },
    certificate_name: {
        flex: 5,
        paddingHorizontal: "20%",
    },
    content: {
        flex: 20,
        paddingHorizontal: 10,
        flexDirection:"row",
        flexWrap:"wrap",
        textAlign:"left",
        alignItems:"flex-start",
        alignContent:"flex-start",
        alignSelf:"flex-start",
        
        justifyContent:'center',
        // paddingVertical: 10,
    },
    certificate_name_container: {
        height: "100%",
        alignContent: "center",
        justifyContent: "center",
        border: "1px solid #ccc",
        borderRadius: 10,
    },
    studentNote:{
        paddingHorizontal: 10,
        paddingVertical: 10,
        alignContent: "center",
        justifyContent: "center",
    },
    certificateNameSection: {
        alignItems: 'center',
        marginBottom: 10,
    },
    dateSection: {
        marginBottom: 10,
    },
    mainContentSection: {
        flexDirection: 'column',
    },
    textSection: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        textAlign: 'left',
        alignItems: 'flex-start',
    },
    gapSection: {
        marginTop: 20,
    },
    notesSection: {
        marginTop: 20,
    }
})



const styleFooter = StyleSheet.create({
    block: {
        flex: 1,
        flexDirection: "column",
        padding: "2 10 2 10",
        // backgroundColor: '#f0f0f0',
    },
    empty_row: {
        flex: 7,
        // height: "70%",
        flexDirection: "row",
    },
    row_labels: {
        flex: 3,
        flexDirection: "row",
        // height: "30%",
    },
    colSign: {
        flex: 1,
        // backgroundColor: '#f0f0f0',
        // border:"1px solid black",
        margin: "5px 20px",
    },
    colSignLabel: {
        flex: 1,
        alignContent:"center"
        // backgroundColor: '#f0f0f0',
    },
    sign_text: {
        fontSize: 12,
        fontFamily: "Helvetica-Bold",
        textAlign: "center",
        alignContent: "center",
        color: "#37353b"
    },
    image_sign: {
        height: "auto",
        maxWidth: "100%",
        // textAlign: "center",
        // padding: 0,
        // justifyContent:"center",
        // alignContent:"center",
        // textAlign:"center",
        // alignItems:"center",
        // alignSelf:"center"
    },
});


const styleHeaderLogo = StyleSheet.create({
    header_logo_section: {
        height: "100%",
        // marginLeft: 15,
        // marginTop: 15,
        padding: 5,
        color: "#000",
        display: 'flex',
        flexDirection: 'row',
        family: 'Calibri',
    },
    header_left: {
        flex: '2',
        height: '100%',
        // borderWidth:innerBorderWidth,
        // borderColor:"#ccc",
        alignContent: "center",
    },
    header_center: {
        flex: '6',
        textAlign: "center",
        justifyContent: "center",
        // fontWeight: 'heavy',
        fontStyle: 'normal',
        // borderWidth:innerBorderWidth,
        // borderColor:"#ccc",
        // fontFamily: "Helvetica-Bold",
    },
    school_header: {
        fontSize: 11,
        paddingTop: 5,
        textTransform: "uppercase",
    },
    header_right: {
        margin: 10,
        padding: 10,
        flex: '2',
        // borderWidth:innerBorderWidth,
        // borderColor:"#ccc",
    },
    image1: {
        maxHeight: "80px",
        maxWidth: "80px",
        // width:"auto",
        // maxWidth: "100%",
        textAlign: "center",
        padding: 0,
        objectFit: "contian",
        // justifyContent:"center",
        // alignContent:"center",
        // textAlign:"center",
        // alignItems:"center",
        // alignSelf:"center"
    },
});


export { pageStyle, styleFooter, styleHeaderLogo, fontStyles, styleContent };